module.exports = __webpack_public_path__ + "assets/img/6.7eae31c0.png";